<template>
  <path
    id="Path"
    d="M12,23.3390281 L10.32,21.6407673 C4.08,16.0607673 0,12.3003325 0,7.69076726 C0,3.93033248 2.88,1.01902813 6.6,1.01902813 C8.64,1.01902813 10.68,1.98946292 12,3.56641944 C13.32,1.98946292 15.36,1.01902813 17.4,1.01902813 C21.12,1.01902813 24,3.93033248 24,7.69076726 C24,12.3003325 19.92,16.0607673 13.68,21.6407673 L12,23.3390281 Z"
    :fill="iconColor"
    fill-rule="nonzero"
  />
</template>

<script>
export default {
    name: 'HeartIcon',
    props: {
        iconColor: {
            type: String,
            default: '#ED1C24'
        }
    }
};
</script>

<style scoped></style>
